import React from "react";
import { translate } from "react-i18next";
import { connect } from "react-redux";
import {
  Chip,
  Button,
  TableRow,
  TableCell,
  Tooltip,
  Collapse,
} from "@material-ui/core";
import PropsTypes from "prop-types";
import { withStyles } from "@material-ui/core/styles";
import NumberFormat from "react-number-format";
import { Link } from "react-router-dom";
import Loading from "../../loading";
import Snackbar from "../../snackbar";
import TableFormat from "../../../partials/TableFormat";
import EditInfo from "./editInfo";
import { _parsePhoneNumber } from "../../../partials/validateNumber";
import { styles } from "./styles";

let headCells = [
  {
    key: "code",
    numeric: false,
    disablePadding: false,
    label: "employees_listemployee_tablehead_employeeNumber",
  },
  {
    key: "name",
    numeric: false,
    disablePadding: false,
    label: "employees_listemployee_tablehead_name",
  },
  {
    key: "nickname",
    numeric: false,
    disablePadding: false,
    label: "employees_listemployee_tablehead_nickname",
  },
  {
    key: "mobile",
    numeric: false,
    disablePadding: false,
    label: "employees_listemployee_tablehead_mobile",
  },
  {
    key: "typeEmployee",
    numeric: false,
    disablePadding: false,
    label: "employees_listemployee_tablehead_employee_type",
  },
  {
    key: "salary",
    numeric: false,
    disablePadding: false,
    label: "employees_listemployee_tablehead_salary",
  },
  {
    key: "active",
    numeric: false,
    disablePadding: false,
    label: "employees_listemployee_tablehead_active",
  },
  { key: "action", numeric: false, disablePadding: false, label: "action" },
];

let headCellsNoViewSalary = [
  {
    key: "code",
    numeric: false,
    disablePadding: false,
    label: "employees_listemployee_tablehead_employeeNumber",
  },
  {
    key: "name",
    numeric: false,
    disablePadding: false,
    label: "employees_listemployee_tablehead_name",
  },
  {
    key: "nickname",
    numeric: false,
    disablePadding: false,
    label: "employees_listemployee_tablehead_nickname",
  },
  {
    key: "mobile",
    numeric: false,
    disablePadding: false,
    label: "employees_listemployee_tablehead_mobile",
  },
  {
    key: "typeEmployee",
    numeric: false,
    disablePadding: false,
    label: "employees_listemployee_tablehead_employee_type",
  },
  {
    key: "active",
    numeric: false,
    disablePadding: false,
    label: "employees_listemployee_tablehead_active",
  },
  { key: "action", numeric: false, disablePadding: false, label: "action" },
];
class ListEmployee extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      order: "asc",
      orderBy: "code",
      selected: [],
      selectedBranch: "",
      dialog: {
        messageConfirm: "",
        content: "",
      },
      collapse: [],
    };
    this.handleSubmitDelete = this.handleSubmitDelete.bind(this);
  }
  componentDidMount() {
    this.props.onRef(this);
    this.setState({ selectedBranch: this.props.selectedBranch });
  }
  getListEmployeeService = async (payload) => {
    this.handleOpenCollapes(-1);
    this.loading.startLoading();
    const { rowsPerPage, page } = this.mTable.state;
    const { search = "" } = this.props;
    const branchCode = this.props.selectedBranch;
    let check = await this.props.employeeDispatch.getListEmployeeService({
      limit: rowsPerPage,
      page: page,
      branchCode: branchCode,
      search: search,
      ...payload,
    });
    if (check.code === 0) {
      this.mSnackbar.handleClick(check.message, "error");
    }
    this.loading.stopLoading();
  };
  handleOpenCollapes = (id) => {
    const { collapse = [] } = this.state;
    const { employees } = this.props;
    for (let i = 0; i <= employees.length; i++) {
      if (i === id) {
        collapse[i] = !collapse[i];
      } else collapse[i] = false;
    }
    this.setState(collapse);
  };
  async handleSubmitDelete(selected = []) {
    let { t } = this.props;
    if (selected && selected.length) {
      let check = await this.props.employeeDispatch.deleteEmployeeService({
        mobileArr: selected,
      });
      if (check.code === 1) {
        this.setState({ selected: [] });
        this.mSnackbar.handleClick(
          t("employees_listemployee_delete_successfully")
        );
        return true;
      } else {
        this.mSnackbar.handleClick(
          t("employees_listemployee_delete_successfully")
        );
        return false;
      }
    } else {
      this.mSnackbar.handleClick(t("pls_select_item"));
      return false;
    }
  }
  handleChange = (value) => {
    this.props.employeeDispatch.changeSelectedBranch(value);
    this.getListEmployeeService({ branchCode: value });
  };
  afterFetch = () => {
    this.handleOpenCollapes(-1);
    this.getListEmployeeService();
  };
  renderActive = (status) => {
    const { t, classes } = this.props;
    if (status === 1)
      return (
        <Chip
          label={t("employees_listemployee_active")}
          className={classes.activeChip}
        />
      );
    else
      return (
        <Chip
          label={t("employees_listemployee_inactive")}
          className={classes.nonActiveChip}
        />
      );
  };
  renderCollapse = (row, index) => {
    const { collapse = [] } = this.state;
    const { employees } = this.props;
    let { classes } = this.props;
    return (
      <TableRow key={index} className={classes.tableRowHeight}>
        <TableCell
          colSpan={headCells.length + 1}
          padding={"none"}
          className={classes.tableCellInCollapes}
        >
          <Collapse in={collapse[index]} unmountOnExit>
            <EditInfo
              afterFetch={this.afterFetch}
              data={employees.find((e) => e.code === row.code)}
            />
          </Collapse>
        </TableCell>
      </TableRow>
    );
  };
  parseBranchCodeArr = (branch) => {
    if (Array.isArray(branch)) {
      let arrBranch = branch.filter((ele) => ele !== undefined);
      return arrBranch.map((e) => {
        if (e.branchCode) {
          return e.branchCode;
        } else {
          return e;
        }
      });
    } else return [];
  };
  actionColumn = (row = {}, index) => {
    const { classes, t, employees = [] } = this.props;
    return (
      <Link to={"/employee/edit/" + employees[index].userCode}>
        <Button
          size="small"
          variant="outlined"
          color="primary"
          className={classes.buttonOnRow}
        >
          {t("customer_listcustomer_edit")}
        </Button>
      </Link>
    );
  };
  render() {
    const {
      t,
      employees = [],
      total,
      infoServiceBranch,
      count,
      moduleRole,
    } = this.props;
    const { collapse } = this.state;
    let ofBranch =
      infoServiceBranch && infoServiceBranch.branchName
        ? ` ${t("of")} ${infoServiceBranch.branchName}`
        : "";

    return (
      <React.Fragment>
        <Snackbar
          color="white"
          onRef={(snackbar) => (this.mSnackbar = snackbar)}
        />
        <Loading onRef={(id) => (this.loading = id)} />
        <TableFormat
          onRef={(ref) => (this.mTable = ref)}
          orderBy=""
          contentDialog={t(
            "employees_listemployee_editemployee_editcontent_are_you_sure_that_you_want_to_fired_employee_out_of_system"
          )}
          onDelete={this.handleSubmitDelete}
          title={`${t("all_employee")} ${ofBranch}`}
          showFilter={false}
          placeholder={t("employees_search")}
          headCells={
            moduleRole &&
            moduleRole.employeeSystem &&
            moduleRole.employeeSystem.viewSalary
              ? headCells
              : headCellsNoViewSalary
          }
          totalCount={total}
          count={count}
          size={"medium"}
          collapse={collapse}
          isCollapse={true}
          renderCollapse={this.renderCollapse}
          handleOpenCollapes={this.handleOpenCollapes}
          actionColumn={this.actionColumn}
          getList={this.getListEmployeeService}
          infoServiceBranch={infoServiceBranch}
          showFilterBranch={true}
          handleChangeBranch={this.handleChange}
          rows={employees.map((row) => {
            return {
              id: JSON.stringify({
                countryCode: row.countryCode,
                mobile: row.mobile,
              }),
              code: row.code,
              name: row.name,
              nickname: row.nickname,
              mobile: _parsePhoneNumber(row.countryCode, row.mobile)
                .format_internal,
              typeEmployee: (
                <div>
                  {row.typeEmployee === "executor" ? (
                    <Tooltip title={t("employee_addemployee_executor")}>
                      <img
                        style={{ width: "2rem" }}
                        src={"/images/icon/massage.png"}
                        alt="employee executor"
                      />
                    </Tooltip>
                  ) : (
                    <Tooltip title={t("employee_addemployee_operator")}>
                      <img
                        style={{ width: "2rem" }}
                        src={"/images/icon/manager.png"}
                        alt="employee operator"
                      />
                    </Tooltip>
                  )}
                </div>
              ),
              salary: (
                <React.Fragment>
                  <NumberFormat
                    thousandSeparator={true}
                    displayType={"text"}
                    value={t(row.salary)}
                  />{" "}
                  {this.props.currencyCode + " /"}{" "}
                  {t("employees_listemployee_" + row.typeSalary)}
                </React.Fragment>
              ),
              active: this.renderActive(row.active),
            };
          })}
        />
      </React.Fragment>
    );
  }
}
ListEmployee.propsTypes = {
  classes: PropsTypes.object.isRequired,
  theme: PropsTypes.object.isRequired,
};

const mapState = (state) => ({
  total: state.employees.total,
  count: state.employees.count,
  employees: state.employees.employee,
  selectedBranch: state.employees.selectedBranch,
  currencyCode: state.setting.setting
    ? state.setting.setting.currencyCode
    : "VND",
  infoServiceBranch: state.serviceBranch.infoServiceBranch,
  moduleRole: state.user.module,
});
const mapDispatch = (dispatch) => ({
  employeeDispatch: dispatch.employees,
});

export default connect(
  mapState,
  mapDispatch
)(
  translate("translations")(
    withStyles(styles, { withTheme: true })(ListEmployee)
  )
);
